import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_3657a70277: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_3657a70277",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Tiny Reader's Library",
  description:
    "A charming collection of board books and educational stories designed to foster early literacy and curiosity in your youngest shoppers.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/e12f7d8c30f128c96f13da3d781451695db0944c88662b0e2a2e6a8ee0b71d0c.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/e12f7d8c30f128c96f13da3d781451695db0944c88662b0e2a2e6a8ee0b71d0c.jpeg",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/0b8bb8796d6eb6384ffb1d2955bc469f4a8e83a1c53e8abae3db0f3501303277.jpeg",
    "https://cdn.faire.com/fastly/528596dc48a61feda89b6cbbad17aed2f2b96569770eb7c35481da07322db17b.png",
    "https://cdn.faire.com/fastly/41fd7f54a71f6e3122c515fe58e8c8f5fe8460b02173d830e3e7398f51c60cd0.jpeg",
    "https://cdn.faire.com/fastly/4321390e4dbff2b6f9c27f243056012483ffdaec6e80d23c09e76e384333c2ed.jpeg",
  ],
  itemCount: 55,
  source: "eric_themes_ideas",
  teaser: "thi_3657a70277",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
